import { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import browserHistory from '../../history';

const S = {
    page: {
        minHeight: 'calc(100vh - 180px)',
        backgroundColor: '#15171b',
        color: '#ffffff',
        padding: '60px 20px',
    },
    container: {
        maxWidth: '760px',
        margin: '0 auto',
    },
    heading: {
        fontSize: '36px',
        fontWeight: '700',
        marginBottom: '12px',
    },
    subheading: {
        fontSize: '18px',
        color: 'var(--highlight, #e9c548)',
        fontWeight: '600',
        marginBottom: '24px',
    },
    body: {
        fontSize: '15px',
        color: '#cccccc',
        lineHeight: '1.8',
        marginBottom: '20px',
    },
    divider: {
        border: 'none',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        margin: '36px 0',
    },
    block: {
        backgroundColor: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: '8px',
        padding: '28px 32px',
        textAlign: 'center',
    },
    blockLabel: {
        fontSize: '13px',
        color: '#aaaaaa',
        letterSpacing: '1px',
        textTransform: 'uppercase',
        marginBottom: '10px',
    },
    blockDesc: {
        fontSize: '14px',
        color: '#aaaaaa',
        marginBottom: '24px',
        lineHeight: '1.7',
    },
    btn: {
        padding: '12px 32px',
        background: 'var(--highlight, #e9c548)',
        border: 'none',
        borderRadius: '4px',
        color: '#15171b',
        fontWeight: '700',
        fontSize: '15px',
        cursor: 'pointer',
        letterSpacing: '0.5px',
    },
};

class Partners extends Component {

    goToVerify(role) {
        browserHistory.push({
            pathname: '/verify',
            state: { userType: role },
        });
    }

    render() {
        const appName = window.app && window.app.appName;

        return (
            <div className="info-page">
                <Header />
                <div style={S.page}>
                    <div style={S.container}>
                        <h1 style={S.heading}>Partner With Us</h1>
                        <p style={S.subheading}>
                            {appName == "usaboxing" ? `READY TO JOIN AS A FIGHTERS?` :
                            `Grow together with a platform built for storytellers.`}
                        </p>

                        <p style={S.body}>
                            {appName == "usaboxing" ? `Apply as a Fighter to participate in the next show for USA Select Boxing and showcase your skills to a global audience. Identity verification is required to keep the community safe and trusted.` :
                            `${appName} is actively seeking strategic partnerships with distributors, production companies,
                            film festivals, technology providers, and content aggregators who share our commitment to
                            quality storytelling and diverse voices.`}


                        </p>

                        {/* Become a Partner block */}
                        <div style={S.block}>
                            <p style={S.blockLabel}>Reach out to explore a partnership</p>
                            <a
                                href={`mailto:partners@${appName}.com`}
                                style={{ fontSize: '20px', fontWeight: '700', color: 'var(--highlight, #e9c548)', textDecoration: 'none', display: 'block', marginBottom: '24px', fontFamily: `var(--bodyfont) !important` }}
                            >
                               {appName == "usaboxing" ? "partners@usaselectboxing.com" : `partners@${appName}.com`}
                            </a>
                            <p style={S.blockDesc}>
                                Complete identity verification to register as a partner on {appName == "usaboxing" ? "USA Select Boxing" : appName}.
                            </p>
                            <button style={S.btn} onClick={() => this.goToVerify('partner')}>
                                Become a {appName == "usaboxing" ? "Boxing Gym" : "Partner"}
                            </button>
                        </div>

                        <hr style={S.divider} />

                        {/* Become a Creator block */}
                        <div style={{ ...S.block, textAlign: 'center' }}>
                            <p style={S.blockLabel}>Ready to join as a creator?</p>
                            <p style={S.blockDesc}>
                                Apply as a creator on {appName} and start sharing your work with a global audience.
                                Identity verification is required to keep the community safe and trusted.
                            </p>
                            <button style={S.btn} onClick={() => this.goToVerify('creator')}>
                                Become a {appName == "usaboxing" ? "Fighters" : "Creator"}
                            </button>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Partners;
